import { twMerge } from "tailwind-merge";

const counterTheme = {
  base: "text-center",
  variants: {
    size: {
      xs: "h-3 px-0.5 text-[9px] min-w-3 leading-3 rounded-sm",
      sm: "h-4 px-1 text-sm min-w-4 leading-4 rounded-sm",
      md: "h-5 py-0.5 px-2 min-w-6 leading-5 h-6 rounded-md",
    },
    variant: {
      default: "bg-warning text-light",
      new: "bg-new text-light",
    },
  },
};

export interface NotificationProps {
  count?: number;
  variant?: keyof typeof counterTheme.variants.variant;
  size?: keyof typeof counterTheme.variants.size;
}

export function NotificationCount({ count, variant = "default", size = "md" }: NotificationProps) {
  return (
    <div
      className={twMerge(
        counterTheme.base,
        counterTheme.variants.variant[variant],
        counterTheme.variants.size[size]
      )}
    >
      {count}
    </div>
  );
}
